var vatMixin = {
    data: function () {
        return {
			incVATTranslation: GLOBAL.TRANSLATIONS.INCVAT,
			exVATTranslation: GLOBAL.TRANSLATIONS.EXVAT,
        }
    },
	methods: { 
		incVAT: function () {
			return vueCurrency.incVAT == 1;
		}
	},
};
